import React from 'react';
import { hashHistory } from 'react-router';
import { Col, Table, Button, Tabs, Tab } from 'react-bootstrap';
import '../css/App.css';

export default class MaintenanceCardsComponent extends React.Component {
	constructor(props) {
		super(props);

		this.checkCard = this.checkCard.bind(this);
		this.onTabsChange = this.onTabsChange.bind(this);
	}

	componentWillMount() {
		let request = this.props.mCaseListRequestModel;
		this.props.clearAlert();
		this.props.reloadMaintenanceCase(request.get('workingTarget'));
		this.props.findMaintenanceCards(request.get('workingTarget'), request.get('tabsKey'));
		this.props.evaluateMaintenanceStatistic(request.get('workingTarget'));
	}

	componentDidMount() {
		//to avoid asyn issue for newx page, query first
		this.props.findCategories();
	}

	generateCheckFile() {
		let ok = confirm('僅會將已完成洗前清點維修卡進行統計');
		if (ok) {
			this.props.generateMaintenanceCheckFileMap(this.props.mCaseListRequestModel.get('workingTarget'));
		}
		return;
	}

	checkCard(cardId) {
		let request = this.props.mCaseListRequestModel;
		this.props.setTargetCard(cardId);

		let tabKey = this.props.mCaseListRequestModel.get('tabsKey');
		if (tabKey === 0) {
			this.props.setMaintenanceCaseChecking(request.get('workingTarget'));
		}

		if (tabKey === 1) {
			this.props.setMaintenanceCaseModified(request.get('workingTarget'));
		}

		this.props.resetCheckFileLink(request.get('workingTarget') + '');
		hashHistory.push("/maintenanceCard");
	}

	showGenerateCheckFileButton() {
		if (this.props.export.get('file')) {
			return false
		} else {
			return true;
		}

	}

	onCheckFileDownLoad() {
		window.open(this.props.files.get(this.props.mCaseListRequestModel.get('workingTarget') + ''));
		this.props.clearAlert();
	}

	backToCasesPage() {
		hashHistory.push("/maintenanceCases");
	}

	sortCards(cards) {
		return this.sortCardsByStatus(cards);
	}

	sortCardsBySerial(cards) {

		cards.sort(function (a, b) { return a.code > b.code });

		return cards;
	}

	sortCardsByStatus(cards) {
		let clothOk = [];
		let pantOk = [];
		let working = [];
		let others = [];

		cards.map((item, index) => {
			if (item.status === 'CLOTH_CHECKED') {
				clothOk.push(item);
			} else if (item.status === 'PANT_CHECKED') {
				pantOk.push(item);
			} else if (item.status === 'WORKING') {
				working.push(item);
			} else {
				others.push(item);
			}
		});

		let ret = clothOk.concat(pantOk).concat(working).concat(others);
		return ret;
	}

	sort(cards, order, orderby) {
		this.props.sortCards(cards, order.get(orderby));
	}

	onTabsChange(tabsKey) {
		let request = this.props.mCaseListRequestModel;
		// this.props.onCardsTabsChange(tabsKey);
		if (0 === tabsKey) {
			this.props.findMaintenanceCards(request.get('workingTarget'), tabsKey);
		}
		if (1 === tabsKey) {
			this.props.findMaintenanceCards(request.get('workingTarget'), tabsKey);
		}
	}

	render() {

		let hideGenerateBtn = { display: 'inline' };

		let hideDownloadLink = { display: 'none' };

		if (this.props.files.get(this.props.mCaseListRequestModel.get('workingTarget') + '') !== undefined) {
			hideGenerateBtn = { display: 'none' };
			hideDownloadLink = { display: 'inline' };
		}

		let bsSize = function (statusKey) {
			// if('COMPLETED'===statusKey){
			// 	return 'small';
			// }
			return 'large';
		}

		let checkingButtonValue = function (statusKey) {
			if ('COMPLETED' === statusKey) {
				return '明細...';
			}
			return '清點...';
		};


		let cardStatus = function (statusKey) {
			switch (statusKey) {
				case 'WORKING':
					return '進行中';

				case 'CHECKING':
					return '清點中';

				case 'COMPLETED':
					return '完成清點';

				case 'MODIFIED':
					return '修改清點';

				case 'REFINED':
					return '已確認';

				case 'FIXING':
					return '維修中';

				case 'FIXED':
					return '維修完成';

				case 'AUDITED':
					return '稽核完成';

				default:
					return "";
			}
		}

		let sortIcon = (field) => {
			let orders = this.props.mCardListViewModel.get('sortOrders');
			let asc = orders.get(field).get('asc');
			let icon;
			if (asc === undefined || orders.get('orderby') !== field) {
				icon = 'sort.svg';
			} else {
				icon = asc ? 'sort-up.svg' : 'sort-dw.svg';
			}

			return <a
				onClick={(event) => {
					this.props.sortCards(
						this.props.mCardListViewModel.get('cardsModel'),
						this.props.mCardListViewModel.get('sortOrders').get(field));
				}
				}>
				<img src={icon} height="18" width="18" className='sort' alt="" />
			</a>
		}

		return (

			<div><Col xs={12} sm={12} md={12}><span hidden>MaintenanceCardsComponent</span>
				<h4>清點作業管理 &gt;&gt; 洗前清點&nbsp;&nbsp;
					<a onClick={(e) => { this.backToCasesPage() }}><img src="back.png" title="回上一頁" alt="回上一頁" style={{ cursor: 'pointer' }} /></a>
				</h4>
				<span className="sub-header">標案基本資料</span>
				<Table striped bordered condensed hover>
					<tbody>
						<tr>
							<th width="35%">
								訂單: {this.props.mCardListViewModel.get('caseModel').orderId}<br />
								時間: {new Date(this.props.mCardListViewModel.get('caseModel').createTime).toLocaleDateString()}<br />
								註記: {this.props.mCardListViewModel.get('caseModel').note}
							</th>
							<th >序號置頂:<br />
								<input type='text' className='form-control-inline'
									onChange={(event) => { this.props.setFilterString(event.target.value); }}
									onKeyDown={(event) => {
										// keyCode = 13 => eneter 鍵
										if (event.keyCode === 13) {
											this.props.resortingMCardsByCriteria(this.props.mCardListViewModel.get('cardsModel'), this.props.mCardListRequestModel.get('filter'));
										}
									}}
									value={this.props.mCardListRequestModel.get('filter')} tabIndex="1" />
								<span className="glyphicon glyphicon-search" style={{ marginLeft: 10, cursor: 'pointer' }} onClick={(event) => {
									this.props.resortingMCardsByCriteria(this.props.mCardListViewModel.get('cardsModel'), this.props.mCardListRequestModel.get('filter'));
								}} tabIndex="2" />
							</th>
							<td hidden style={{ textAlign: "center", width: "15%", verticalAlign: "middle" }}><span><Button bsStyle="success"
								onClick={(event) => { this.generateCheckFile(); }} style={hideGenerateBtn}>產生清點表</Button>
								<a onClick={(event) => { this.onCheckFileDownLoad() }} style={hideDownloadLink}>下載清點表</a>&nbsp;&nbsp;
								<a href="doc/download_check_file.html" target="_blank">
									<img src='question.svg' height="20" width="20" style={{ display: 'inline' }} alt='清點表說明' />
								</a></span>
							</td>
						</tr>
					</tbody>
				</Table>
				<Tabs id="mCardsTabs"
					defaultActiveKey={0}
					animation={false}
					onSelect={this.onTabsChange}>
					<Tab eventKey={0} title='待清點'>
					</Tab>
					<Tab eventKey={1} title='已完成'>
					</Tab>
				</Tabs>
				<div style={{ marginTop: 10 }}>
					<span className="sub-header">清洗維修卡&nbsp;&nbsp;{this.props.mCardListViewModel.get('statistis').complete}/{this.props.mCardListViewModel.get('statistis').total}</span>
					<Table striped bordered condensed hover>
						<thead>
							<tr>
								<th>序號 {sortIcon("code")}</th>
								<th>開始清點</th>
								<th>單位 {sortIcon("unit")}</th>
								<th>使用者 {sortIcon("owner")}</th>
								<th>建立時間</th>
								<th>狀態 {sortIcon("status")}</th>
							</tr>
						</thead>
						<tbody>
							{
								this.props.mCardListViewModel.get('cardsModel').map(
									/*this.sortCards(this.props.mCardListViewModel.get('cardsModel')).map(*/
									(item, index) =>
										<tr key={index}>
											<td>{item.code}</td>
											<td>
												<Button bsStyle="primary" bsSize={bsSize(item.status)} onClick={(event) => { this.checkCard(item.id); }}>
													{checkingButtonValue(item.status)}
												</Button>
											</td>
											<td>{item.organization}{item.unit}</td>
											<td>{item.owner}</td>
											<td>{new Date(item.createTime).toLocaleDateString()}</td>
											<td>{cardStatus(item.status)}</td>
										</tr>
								)
							}
						</tbody>
					</Table>
				</div>
			</Col>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceCardsComponent.jsx